import React from 'react'

export default class FunctionalIndexText extends React.Component {
  render () {
    return (
      <div className='someText' contentEditable='true'>
        <div className='someText-body'>
          <span>
            El<strong className='blue'> El Índice de capacidad funcional</strong> es una medición integral del estado de salud con base en 5 componentes.
             Cada uno tiene un valor máximo de 10, al igual  que el índice. Su estado en los <strong className='blue'> cinco componentes</strong> es:
          </span>
          <ul>
            { (this.props.propiedades.fxarterial === 'regular')
              ? <li>
                  <strong className='blue'>Función arterial: </strong>
                  <span>
                    Su sistema circulatorio puede estar con sobrecargas, evalúe si su nivel de actividad y ejercicio es bueno. Recuerda que fumar lesiona sus arterias y pulmones. Revise su edad arterial.
                  </span>
                </li>
              : (this.props.propiedades.fxarterial === 'excelente')
              ? <li>
                  <strong className='blue'>Función arterial: </strong>
                  <span>Su sistema circulatoria funciona bien.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.fxmetabolica === 'regular')
              ? <li>
                  <strong className='blue'>Función metabólica: </strong>
                  <span>
                    Ha ganado peso y no solo su cuerpo lo siente: también su metabolismo se afecta. Revise su perímetro abdominal.
                  </span>
                </li>
              : (this.props.propiedades.fxmetabolica === 'excelente')
              ? <li>
                  <strong className='blue'>Función metabólica: </strong>
                  <span>Su peso y su metabolismo están en forma.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.fxcardiopulmonar === 'regular')
              ? <li>
                  <strong className='blue'>Función cardiopulmonar: </strong>
                  <span>
                    Sin ejercicio, su capacidad cardiaca y pulmonar se reduce y eso acelera el envejecimiento. Ingrese a un programa de ejercicio. Mejore su respiración.
                  </span>
                </li>
              : (this.props.propiedades.fxcardiopulmonar === 'excelente')
              ? <li>
                  <strong className='blue'>Función cardiopulmonar: </strong>
                  <span>Su capacidad física y función cardiopulmonar son buenas.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.afectivoBienestar === 'regular')
              ? <li>
                  <strong className='blue'>Balance afectivo y bienestar: </strong>
                  <span>
                    El estado emocional es el motor de su vida. Debe mejorar su BIENESTAR. Solicite apoyo para lograrlo.
                  </span>
                </li>
              : (this.props.propiedades.afectivoBienestar === 'excelente')
              ? <li>
                  <strong className='blue'>Balance afectivo y bienestar: </strong>
                  <span> Tiene bienestar y balance emocional.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.vigorBN === 'regular')
              ? <li>
                  <strong className='blue'>Vigor físico: </strong>
                  <span>
                    Con los años el vigor general disminuye, el equilibrio es menor. Necesitas estar física y mentalmente más fuerte.
                  </span>
                </li>
              : (this.props.propiedades.vigorBN === 'excelente')
              ? <li>
                  <strong className='blue'>Vigor físico: </strong>
                  <span>Su condición neuromuscular es buena. Tiene buen balance.</span>
                </li>
              : ''
            }
          </ul>
        </div>
      </div>
    )
  }
}

/* Validate Props */
FunctionalIndexText.propTypes = {
  propiedades: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/capacidadFuncText.js